<script>
import { mapGetters } from "vuex";

export default {
  name: "Bahn1RecapVideo",
  computed: {
    ...mapGetters("bahn1", ["recap"]),
    videoUrl() {
      return this.recap && this.recap.RecapVideo
        ? this.$store.getters.getStrapiDocumentUrl(this.recap.RecapVideo)
        : null;
    }
  }
};
</script>

<template>
  <div class="recap-video" v-if="recap && recap.RecapVideo">
    <h2>Recap Video</h2>
    <p v-if="recap.RecapText">{{ recap.RecapText }}</p>
    <video
      class="recap-video-player"
      :src="videoUrl"
      controls
      preload="metadata"
    ></video>
  </div>
</template>

<style scoped>
.recap-video {
  width: 100%;
  margin-bottom: 56px;
}
.recap-video-player {
  width: 100%;
  height: 556px;
  object-fit: contain;
  display: block;
  background: #000;
}
h2 {
  margin-top: 56px;
  margin-bottom: 16px;
  font-size: 30px;
  letter-spacing: 0.6px;
}
p {
  margin-bottom: 24px;
  letter-spacing: 0.32px;
  font-family: "GeometriaLight";
}
</style>
